import { LockKeyhole, SquareDashedMousePointer } from "lucide-react";
import React from "react";

import {
  IgAvatar,
  IgButton,
  IgDivider,
  IgTypography,
} from "@intelligems/ig-theme";
import { useTheme } from "@mui/material";
import Stack from "@mui/material/Stack";
import { CopyFromOtherGroupsAccordion } from "@src/features/experienceBuilder/modifications/copyMod/CopyFromOtherGroupsAccordion";
import { useDispatch, useSelector } from "@src/store";
import {
  ExperienceBuilderAction as Action,
  ExperienceBuilderSelector as Selector,
} from "@src/store/slices/experienceBuilder";

export const ModificationsSelectEmptyState = () => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const lockStatus = useSelector(Selector.getModificationsLockStatus);
  const shouldShowOtherMods = useSelector(Selector.shouldShowOtherMods);

  const handleLock = () => dispatch(Action.setControlGroupLocked(true));

  return (
    <>
      <Stack
        alignItems="center"
        justifyContent="center"
        spacing={2.5}
        sx={{
          px: 2.5,
          py: 8,
          textAlign: "center",
          ...(shouldShowOtherMods ? { height: 363 } : { flex: 1 }),
        }}
      >
        <IgAvatar
          variant="circular"
          sx={{
            backgroundColor: theme.igPrimitives.gray[900],
            width: 50,
            height: 50,
          }}
        >
          <SquareDashedMousePointer
            size={24}
            color={theme.palette.text.secondary}
          />
        </IgAvatar>
        <Stack spacing={1} alignItems="center" maxWidth={292}>
          <IgTypography fontWeight={600}>
            Select an element in the preview
          </IgTypography>
          <IgTypography variant="body2" color={theme.palette.text.secondary}>
            Select an element in the preview to start creating content
            modifications.
          </IgTypography>
        </Stack>
        {lockStatus === "unlocked" && (
          <IgButton
            variant="outlined"
            color="secondary"
            startIcon={<LockKeyhole size={16} />}
            onClick={handleLock}
          >
            Lock control group
          </IgButton>
        )}
      </Stack>
      {shouldShowOtherMods && (
        <>
          <IgDivider />
          <Stack sx={{ px: 4 }}>
            <CopyFromOtherGroupsAccordion />
          </Stack>
        </>
      )}
    </>
  );
};
